import './PreguntasFrecuentesContainer.css';
import { Accordion } from '@mantine/core';
import axios from 'axios';
import { useEffect, useState } from 'react';
import ThinkingDog from '../../assets/FrecuentQuestions/attention.gif';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import ContactCard from '../Contact/ContactCard/ContactCard';
import showNotification from '../../utils/showNotification';

const PreguntasFrecuentesContainer = () => {
  const { width } = useWindowDimensions();
  const isMobile = width <= 768;
  const [faqs, setFaqs] = useState([]);
  const [isMount, setIsMount] = useState(true);

  const fetchFaqs = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_SERVER}/info/faqs/landing`,
      );
      const data = response?.data;
      setFaqs(data);
    } catch (error) {
      console.error("Error fetching Help Center data:", error);
      showNotification({
        color: "red",
        status: "error",
        title: "Ha ocurrido un problema al cargar las preguntas frecuentes.",
        message: `Detalle: ${error?.message || ""}`,
        autoClose: 12000
      })
    }
  };

  useEffect(() => {
    if (isMount) {
      setIsMount(false);
    } else {
      fetchFaqs();
    }
  }, [isMount]);

  return (
    <div className='preguntasFrecuentesContainer-father-div'>
      <div className="preguntasFrecuentesContainer-grid">
        {isMobile ? (
          <>
            <div className='preguntasFrecuentesContainer-content'>
              <h2 className="preguntasFrecuentesContainer-title">
                Preguntas frecuentes
              </h2>
            
              <Accordion
                classNames={{ label: 'preguntasFrecuentesContainer-accordion-labels', panel: 'preguntasFrecuentesContainer-accordion-panel' }}
                chevronPosition="right"
                variant="separated"
              >
                {faqs.map((faq) => (
                  <Accordion.Item key={faq._id} value={faq._id}>
                    <Accordion.Control>{faq.question}</Accordion.Control>
                    <Accordion.Panel><p className='preguntasFrecuentesContainer-accordion--text'>{faq.answer}</p></Accordion.Panel>

                  </Accordion.Item>
                ))}
              </Accordion>
            </div>
            <div className='preguntasFrecuentesContainer-contactCard-div'>
              <ContactCard />
            </div>
          </>
        ) : (
          <>
            <div className='preguntasFrecuentesContainer-div-image'>
              <img className='preguntasFrecuentesContainer-image' src={ThinkingDog} alt="Frequently Asked Questions" />
            </div>
            <div className='preguntasFrecuentesContainer-content'>
              <h2 className="preguntasFrecuentesContainer-title">
                Preguntas frecuentes
              </h2>
              <Accordion
                classNames={{ label: 'preguntasFrecuentesContainer-accordion-labels', panel: 'preguntasFrecuentesContainer-accordion-panel' }}
                chevronPosition="right"
                variant="separated"
              >
                {faqs.map((faq) => (
                  <Accordion.Item key={faq._id} value={faq._id}>
                    <Accordion.Control>{faq.question}</Accordion.Control>
                    <Accordion.Panel><p className='preguntasFrecuentesContainer-accordion--text'>{faq.answer}</p></Accordion.Panel>
                  </Accordion.Item>
                ))}
              </Accordion>
            </div>
            <div className='preguntasFrecuentesContainer-contactCard-div'>
              <h4 className='preguntasFrecuentesContainer-contactCard-text'>Nuestro servicio de asistencia personalizada está ansioso por resolver tus dudas. ¡Aprovéchalo!</h4>
              <ContactCard />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PreguntasFrecuentesContainer;